/* ==========================================================================
   smellBgone Formula Finder — vanilla-JS port of WizardFinder.tsx + the routing
   model in finderWizard.ts / finder.ts.

   4 steps: (1) mess type(s) or "protect new turf", (2) surface(s), (3) size,
   (4) recommended kit. The routing (surfacesForMess / kindsForSurfaces /
   resolveKit) is ported verbatim so recommendations match the Hydrogen site.
   Product/variant data comes from a section-rendered JSON blob (money
   pre-formatted server-side). Result cards add to cart via /cart/add.js
   (PLUS+/SYNTURF) or link to the quote page (PETFILL, quote-only).
   ========================================================================== */
(function () {
  // ---- Taxonomy (ported from finderWizard.ts) ----------------------------
  var MESS_TYPES = [
    { id: 'urine', label: 'Urine', spread: 'pervasive' },
    { id: 'faeces', label: 'Faeces', spread: 'pervasive' },
    { id: 'vomit', label: 'Vomit', spread: 'spot' },
    { id: 'blood', label: 'Blood', spread: 'spot' },
    { id: 'odour', label: 'Just odour', spread: 'pervasive' },
    { id: 'other', label: 'Something else', spread: 'pervasive' },
  ];
  var PREVENT = { id: 'prevent', label: 'Protecting new turf' };
  var SURFACES = [
    { id: 'carpet', label: 'Carpet', sizeKind: 'frequency', spotOk: true, products: ['plus'] },
    { id: 'sofa', label: 'Upholstery', sizeKind: 'frequency', spotOk: true, products: ['plus'] },
    { id: 'mattress', label: 'Mattress', sizeKind: 'frequency', spotOk: true, products: ['plus'] },
    { id: 'petbed', label: 'Pet bed', sizeKind: 'frequency', spotOk: true, products: ['plus'] },
    { id: 'fabric', label: 'Fabric', sizeKind: 'frequency', spotOk: true, products: ['plus'] },
    { id: 'floor', label: 'Floor', sizeKind: 'frequency', spotOk: true, products: ['plus'] },
    { id: 'paving', label: 'Paving', sizeKind: 'frequency', spotOk: true, products: ['plus'] },
    { id: 'car', label: 'Car', sizeKind: 'frequency', spotOk: true, products: ['plus'] },
    { id: 'lawn', label: 'Natural lawn', sizeKind: 'frequency', spotOk: true, products: ['plus'] },
    { id: 'turf', label: 'Synthetic turf', sizeKind: 'turf', spotOk: false, products: 'turf' },
    { id: 'kennel', label: 'Kennel', sizeKind: 'kennel', spotOk: false, products: ['synturf'] },
    { id: 'commercial', label: 'Commercial', sizeKind: 'commercial', spotOk: false, products: ['synturf'] },
    { id: 'unsure', label: 'Not sure', sizeKind: 'frequency', spotOk: true, products: ['plus'] },
  ];
  var SIZE_KINDS = {
    frequency: {
      question: 'How often?',
      mark: 'often',
      lede: 'Match your usual clean-up routine.',
      prompt: 'How often?',
      options: [
        { id: 'odd', label: 'The odd accident', tier: 0, reason: 'for the odd clean-up' },
        { id: 'sometimes', label: 'Now and then', tier: 1, reason: 'for occasional clean-ups' },
        { id: 'weekly', label: 'Most weeks', tier: 2, reason: 'for weekly clean-ups' },
        { id: 'daily', label: 'Most days', tier: 3, reason: 'for daily clean-ups' },
      ],
    },
    turf: {
      question: 'How big is the turf?',
      mark: 'turf',
      lede: 'Pick the closest match.',
      prompt: 'Turf size',
      options: [
        { id: 'balcony', label: 'Balcony', tier: 0, reason: 'for your balcony' },
        { id: 'garden', label: 'Garden', tier: 1, reason: 'for your garden' },
        { id: 'frontyard', label: 'Front yard', tier: 2, reason: 'for your front yard' },
        { id: 'field', label: 'Sports field', tier: 3, reason: 'for your sports field' },
      ],
    },
    kennel: {
      question: 'How big is the setup?',
      mark: 'setup',
      lede: 'Pick the closest match.',
      prompt: 'Setup size',
      options: [
        { id: 'one', label: '1 run', tier: 0, reason: 'for your run' },
        { id: 'few', label: 'A few runs', tier: 1, reason: 'for your runs' },
        { id: 'block', label: 'A block', tier: 2, reason: 'for your block' },
        { id: 'facility', label: 'Whole facility', tier: 3, reason: 'for your facility' },
      ],
    },
    commercial: {
      question: 'How big is the space?',
      mark: 'space',
      lede: 'Pick the closest match.',
      prompt: 'Space size',
      options: [
        { id: 'room', label: '1 room', tier: 0, reason: 'for your room' },
        { id: 'floor', label: 'A floor', tier: 1, reason: 'for your floor' },
        { id: 'building', label: 'A building', tier: 2, reason: 'for your building' },
        { id: 'sites', label: 'Multiple sites', tier: 3, reason: 'for your sites' },
      ],
    },
  };
  var TURF_TIER_SQM = { 0: 5, 1: 15, 2: 50 };

  function surfacesForMess(messIds, prevent) {
    if (prevent)
      return SURFACES.filter(function (s) {
        return s.id === 'turf';
      });
    if (messIds.size === 0) return SURFACES;
    var hasPervasive = MESS_TYPES.some(function (m) {
      return messIds.has(m.id) && m.spread === 'pervasive';
    });
    return hasPervasive
      ? SURFACES
      : SURFACES.filter(function (s) {
          return s.spotOk;
        });
  }
  function kindsForSurfaces(surfaceIds) {
    var seen = [];
    SURFACES.forEach(function (s) {
      if (surfaceIds.has(s.id) && s.sizeKind && seen.indexOf(s.sizeKind) === -1) seen.push(s.sizeKind);
    });
    return seen;
  }
  function chosenSize(kind, sizeByKind) {
    var opt =
      (SIZE_KINDS[kind] &&
        SIZE_KINDS[kind].options.filter(function (o) {
          return o.id === sizeByKind[kind];
        })[0]) ||
      null;
    return opt ? { tier: opt.tier, reason: opt.reason } : null;
  }
  var KIT_ORDER = ['plus', 'synturf', 'petfill'];
  function resolveKit(surfaceIds, sizeByKind, prevent) {
    var acc = {};
    function contribute(key, label, surfaceId, primary, area, tier, reason) {
      var e = acc[key] || (acc[key] = { key: key, labels: [], surfaces: [], hasArea: false, tier: null, reason: null, companion: false });
      if (primary) {
        e.labels.push(label);
        e.surfaces.push(surfaceId);
      } else e.companion = true;
      if (area) {
        e.hasArea = true;
        if (tier !== null && (e.tier === null || tier > e.tier)) {
          e.tier = tier;
          e.reason = reason;
        }
      }
    }
    SURFACES.forEach(function (s) {
      if (!surfaceIds.has(s.id)) return;
      var label = s.label.toLowerCase();
      var sized = s.sizeKind ? chosenSize(s.sizeKind, sizeByKind) : null;
      var isArea = !!s.sizeKind;
      var tier = sized ? sized.tier : null;
      var reason = sized ? sized.reason : null;
      if (s.products === 'turf') {
        if (prevent) contribute('petfill', label, s.id, true, true, tier, reason);
        else {
          contribute('synturf', label, s.id, true, true, tier, reason);
          contribute('petfill', label, s.id, false, true, tier, reason);
        }
        return;
      }
      s.products.forEach(function (k) {
        contribute(k, label, s.id, true, isArea, tier, reason);
      });
    });
    return KIT_ORDER.filter(function (k) {
      return acc[k];
    }).map(function (k) {
      return acc[k];
    });
  }

  // ---- Copy (fallback composer from finder.ts) ---------------------------
  var SURFACE_LEAD = {
    carpet: 'In the carpet',
    sofa: 'On the upholstery',
    mattress: 'On the mattress',
    petbed: 'On the pet bed',
    fabric: 'In the fabric',
    floor: 'On a hard floor',
    paving: 'On the paving',
    car: 'In the car',
    lawn: 'On the lawn',
    unsure: 'Wherever it has landed',
  };
  var PLUS_STAIN = {
    urine: 'pet urine dries into odour-locking uric-acid crystals that water just spreads around',
    faeces: 'faeces leaves behind bacteria and staining that ordinary cleaning only smears about',
    vomit: "vomit's acids and food matter sink in and keep on smelling",
    blood: 'blood is a set-in protein stain that soap and bleach struggle to shift',
    odour: 'the smell is organic residue that has soaked deep into the surface',
    other: 'an organic stain soaks in and keeps releasing odour',
  };
  var MESS_PRIORITY = ['blood', 'urine', 'vomit', 'faeces', 'odour', 'other'];
  var PERVASIVE = ['urine', 'faeces', 'odour', 'other'];
  function composedWhy(key, mess, surface) {
    if (key === 'synturf') return 'Kills the bacteria behind the odour at the source.';
    if (key === 'petfill') return 'Absorbs pet urine and locks the ammonia away, so odour never takes hold in the turf.';
    return (
      (SURFACE_LEAD[surface] || 'Wherever it has landed') +
      ', ' +
      (PLUS_STAIN[mess] || PLUS_STAIN.other) +
      ', so the plant enzymes digest it at the source and clear the smell for good.'
    );
  }

  // ---- Authored scenario copy (ported verbatim from app/data/finderCopy.ts) ----
  // PLUS+ — 6 mess types x 10 spot surfaces.
  var PLUS_WHY = {
    urine: {
      carpet: 'Breaks down the dried urine crystals deep in the carpet, so the ammonia is gone for good, not just wet again.',
      sofa: 'Digests the residue worked deep into the upholstery padding, lifting stain and smell together while staying gentle on the fabric.',
      mattress: 'Breaks down the urine crystals inside the foam, so the mattress stops flaring up whenever the bed warms.',
      petbed: 'Digests the dried-in urine right through the pet bed padding, so it stops smelling for good.',
      fabric: 'Breaks the urine crystals down in the weave, lifting the mark and the odour humidity keeps reviving.',
      floor: "Clears dried urine from the grout and edges a mop only spreads around, so the smell can't creep back.",
      paving: 'Soaks into porous pavers and digests the urine baked into them, clearing the smell for good.',
      car: 'Breaks down the acrid urine crystals dried into car carpet and seats, so it smells clean, not vacuumed over.',
      lawn: 'Digests the urine residue behind the ammonia haze on the lawn, with no harsh chemicals on the grass.',
      unsure: "Breaks down the ammonia-locking urine crystals wherever they've landed, so the smell is gone, not masked.",
    },
    faeces: {
      carpet: 'Digests the faecal residue and bacteria worked into the carpet pile, so scrubbing never spreads the smell further.',
      sofa: "Breaks down the faecal residue trapped in the upholstery's weave, lifting the stain without smearing it deeper in.",
      mattress: 'Digests the faecal residue and bacteria inside the mattress fibres, clearing the smell instead of pushing it deeper.',
      petbed: "Breaks down the faecal residue worked into the pet bed's padding, so the smell doesn't keep resurfacing.",
      fabric: 'Digests the faecal residue caught in the weave, lifting the stain and the bacteria behind the smell together.',
      floor: 'Clears the bacteria faeces leaves behind in grout and seams that mopping alone just spreads around.',
      paving: 'Soaks into porous paving and digests the faecal residue baked into it, clearing the smell for good.',
      car: "Breaks down the faecal residue worked into car carpet and upholstery, so the smell doesn't linger on every trip.",
      lawn: 'Digests the faecal residue and bacteria left on the lawn, clearing the smell without harsh chemicals on the grass.',
      unsure: "Breaks down the faecal residue and bacteria wherever it's landed, clearing the smell rather than smearing it around.",
    },
    vomit: {
      carpet: 'Digests the acids and food matter vomit leaves sunk into the carpet pile, clearing the smell instead of masking it.',
      sofa: "Breaks down the vomit residue worked into the upholstery's padding, lifting the stain before the acids can set in.",
      mattress: "Digests the vomit residue soaked into the mattress foam, so the smell doesn't keep resurfacing.",
      petbed: "Breaks down the acids and food matter vomit leaves in the pet bed's padding, clearing the smell for good.",
      fabric: 'Digests the vomit residue caught in the fabric weave, lifting the stain before it can set.',
      floor: 'Clears the vomit residue from grout and seams that a wipe alone just spreads around.',
      paving: 'Soaks into porous paving and digests the vomit residue before it can bake into a lingering smell.',
      car: 'Breaks down the vomit residue worked into car carpet and seats, clearing the smell instead of covering it up.',
      lawn: 'Digests the vomit residue on the lawn, clearing the smell without harsh chemicals on the grass.',
      unsure: "Breaks down the vomit residue wherever it's landed, digesting the acids before the smell can set in.",
    },
    blood: {
      carpet: 'Digests the protein blood leaves set into the carpet pile, lifting a stain soap and bleach only struggle to shift.',
      sofa: "Breaks down the protein worked into the upholstery's weave, lifting a blood stain before it can set for good.",
      mattress: 'Digests the protein blood leaves inside the mattress fibres, clearing the stain instead of just fading it.',
      petbed: "Breaks down the protein blood leaves in the pet bed's padding, lifting the stain rather than smearing it.",
      fabric: 'Digests the protein caught in the fabric weave, lifting a blood stain that ordinary washing only sets.',
      floor: 'Clears the protein blood leaves in grout and seams, lifting the stain a wipe just smears around.',
      paving: 'Soaks into porous paving and digests the protein before a blood stain can set into the surface.',
      car: 'Breaks down the protein worked into car carpet and seats, lifting a blood stain other cleaners only fade.',
      lawn: 'Digests the protein blood leaves on the lawn, clearing the stain without harsh chemicals on the grass.',
      unsure: 'Breaks down the set-in protein wherever the blood has landed, lifting a stain other cleaners only fade.',
    },
    odour: {
      carpet: "Digests the organic residue buried in the carpet pile that's causing the smell, even with no mark to show for it.",
      sofa: "Breaks down the organic residue worked into the upholstery's padding, clearing the smell at the source, not just covering it.",
      mattress: 'Digests the organic residue inside the mattress that keeps the smell coming back, without a visible stain to chase.',
      petbed: "Breaks down the organic residue buried in the pet bed's padding, clearing the smell instead of masking it.",
      fabric: "Digests the organic residue caught in the fabric weave that's behind the smell, even without a visible mark.",
      floor: 'Clears the organic residue hiding in grout and seams that keeps the smell coming back after mopping.',
      paving: 'Soaks into porous paving and digests the organic residue baked in, clearing the smell at the source.',
      car: 'Breaks down the organic residue worked into car carpet and seats that air fresheners only cover up.',
      lawn: 'Digests the organic residue on the lawn behind the smell, without harsh chemicals on the grass.',
      unsure: "Breaks down the organic residue behind the smell wherever it's hiding, clearing it at the source, not masking it.",
    },
    other: {
      carpet: "Breaks down whatever's soaked into the carpet pile, digesting the stain and the smell together, no matter the cause.",
      sofa: "Digests whatever's worked into the upholstery's weave, lifting the mark instead of smearing it further in.",
      mattress: "Breaks down whatever's soaked into the mattress fibres, clearing the smell rather than pushing it deeper.",
      petbed: "Digests whatever's worked into the pet bed's padding, clearing the mark and the smell for good.",
      fabric: "Breaks down whatever's caught in the fabric weave, lifting the mark before it can set for good.",
      floor: "Clears whatever's settled into grout and seams that ordinary wiping just spreads around.",
      paving: "Soaks into porous paving and digests whatever's baked in before it can turn into a lingering smell.",
      car: "Breaks down whatever's soaked into car carpet and seats, clearing the smell instead of covering it up.",
      lawn: "Digests whatever's landed on the lawn, clearing the smell without harsh chemicals on the grass.",
      unsure: "Breaks down whatever's landed, wherever it's landed, clearing the stain and the smell at the source.",
    },
  };
  // SYNTURF — 4 pervasive messes x 3 area surfaces.
  var SYNTURF_WHY = {
    urine: {
      turf: 'Kills the bacteria behind the ammonia trapped deep in the turf infill.',
      kennel: 'Kills the urine bacteria building up across kennel floors, and stays safe around the dogs once dry.',
      commercial: 'Kills the bacteria behind the urine smell across large commercial floors and turf.',
    },
    faeces: {
      turf: 'Kills the E. coli and other bacteria faeces leaves trapped deep in the turf infill.',
      kennel: 'Kills the E. coli and bacteria that build up fast across kennel and run floors, and stays safe around the dogs once dry.',
      commercial: 'Kills the E. coli and bacteria behind faecal odour across large commercial floors and turf.',
    },
    odour: {
      turf: 'Kills the bacteria behind stubborn odours trapped deep in the turf infill, not just the smell on top.',
      kennel: 'Kills the bacteria behind stubborn odours across kennel and run floors, and stays safe around the dogs once dry.',
      commercial: 'Kills the bacteria behind stubborn odours across large commercial floors and turf, not just the smell on top.',
    },
    other: {
      turf: "Kills the bacteria behind whatever's causing the smell, deep in the turf infill.",
      kennel: "Kills the bacteria behind whatever's causing the smell across kennel and run floors, and stays safe around the dogs once dry.",
      commercial: "Kills the bacteria behind whatever's causing the smell across large commercial floors and turf.",
    },
  };
  // PETFILL — protect-after companion on cleaned turf, per pervasive mess.
  var PETFILL_COMPANION = {
    urine: "Soaks up fresh urine and locks the ammonia away, so cleaned turf can't pick the smell back up, for years.",
    faeces:
      "Now the turf's clean, the mineral infill keeps it that way, soaking up whatever comes next and locking the ammonia away before odour builds back in.",
    odour: "Now the smell's gone, the mineral infill keeps it that way, soaking up future urine and locking the ammonia away for years.",
    other: "Now it's clean, the mineral infill keeps it protected, soaking up future accidents and locking the ammonia away for years.",
  };
  // PETFILL — the prevention path (new or freshly cleaned turf, no active mess).
  var PETFILL_PREVENT = 'Absorbs pet urine and locks the ammonia away, so odour never takes hold in new turf, for years.';

  // Scenario-specific sell: mirrors finderWhy() in app/data/finder.ts — pick the
  // primary mess by priority, map to a pervasive mess, look up the authored line,
  // and fall back to composedWhy for any slot not yet authored (blank).
  function finderWhy(key, messSet, surfaceIds, isCompanion) {
    var surface = (surfaceIds && surfaceIds[0]) || '';
    var mess = 'other';
    for (var i = 0; i < MESS_PRIORITY.length; i++) {
      if (messSet && messSet.has(MESS_PRIORITY[i])) {
        mess = MESS_PRIORITY[i];
        break;
      }
    }
    var pmess = PERVASIVE.indexOf(mess) !== -1 ? mess : 'other';

    var line = '';
    if (key === 'petfill') {
      line = isCompanion ? PETFILL_COMPANION[pmess] : PETFILL_PREVENT;
    } else if (key === 'synturf') {
      line = (SYNTURF_WHY[pmess] && SYNTURF_WHY[pmess][surface]) || '';
    } else {
      line = (PLUS_WHY[mess] && PLUS_WHY[mess][surface]) || '';
    }
    return (line && line.trim()) || composedWhy(key, mess, surface);
  }
  // Icon geometry is Tabler's, copied verbatim from
  // snippets/tabler-icon.liquid — the one place path data lives. It used to be
  // hand-simplified approximations here (the paw, sofa, bed, dog, plant and grid
  // were visibly not Tabler), which is what put non-Tabler glyphs on the finder's
  // "Fabric-safe" / "Pet-safe" chips. Keys are the real Tabler slugs now, so the
  // two tables can be compared: theme-qa/lint-icons.rb fails the build if a slug
  // present in both files disagrees. Do not edit a path here — edit the snippet.
  var ICONS = {
    droplet:
      '<path d="M7.502 19.423c2.602 2.105 6.395 2.105 8.996 0c2.602 -2.105 3.262 -5.708 1.566 -8.546l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546" />',
    paw: '<path d="M14.7 13.5c-1.1 -2 -1.441 -2.5 -2.7 -2.5c-1.259 0 -1.736 .755 -2.836 2.747c-.942 1.703 -2.846 1.845 -3.321 3.291c-.097 .265 -.145 .677 -.143 .962c0 1.176 .787 2 1.8 2c1.259 0 3 -1 4.5 -1s3.241 1 4.5 1c1.013 0 1.8 -.823 1.8 -2c0 -.285 -.049 -.697 -.146 -.962c-.475 -1.451 -2.512 -1.835 -3.454 -3.538" /><path d="M20.188 8.082a1.039 1.039 0 0 0 -.406 -.082h-.015c-.735 .012 -1.56 .75 -1.993 1.866c-.519 1.335 -.28 2.7 .538 3.052c.129 .055 .267 .082 .406 .082c.739 0 1.575 -.742 2.011 -1.866c.516 -1.335 .273 -2.7 -.54 -3.052l-.001 0" /><path d="M9.474 9c.055 0 .109 0 .163 -.011c.944 -.128 1.533 -1.346 1.32 -2.722c-.203 -1.297 -1.047 -2.267 -1.932 -2.267c-.055 0 -.109 0 -.163 .011c-.944 .128 -1.533 1.346 -1.32 2.722c.204 1.293 1.048 2.267 1.933 2.267" /><path d="M16.456 6.733c.214 -1.376 -.375 -2.594 -1.32 -2.722a1.164 1.164 0 0 0 -.162 -.011c-.885 0 -1.728 .97 -1.93 2.267c-.214 1.376 .375 2.594 1.32 2.722c.054 .007 .108 .011 .162 .011c.885 0 1.73 -.974 1.93 -2.267" /><path d="M5.69 12.918c.816 -.352 1.054 -1.719 .536 -3.052c-.436 -1.124 -1.271 -1.866 -2.009 -1.866c-.14 0 -.277 .027 -.407 .082c-.816 .352 -1.054 1.719 -.536 3.052c.436 1.124 1.271 1.866 2.009 1.866c.14 0 .277 -.027 .407 -.082" />',
    'shield-check':
      '<path d="M11.46 20.846a12 12 0 0 1 -7.96 -14.846a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 -.09 7.06" /><path d="M15 19l2 2l4 -4" />',
    'border-all': '<path d="M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -12" /><path d="M4 12l16 0" /><path d="M12 4l0 16" />',
    sofa: '<path d="M4 11a2 2 0 0 1 2 2v1h12v-1a2 2 0 1 1 4 0v5a1 1 0 0 1 -1 1h-18a1 1 0 0 1 -1 -1v-5a2 2 0 0 1 2 -2" /><path d="M4 11v-3a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v3" /><path d="M12 5v9" />',
    bed: '<path d="M5 9a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" /><path d="M22 17v-3h-20" /><path d="M2 8v9" /><path d="M12 14h10v-2a3 3 0 0 0 -3 -3h-7v5" />',
    dog: '<path d="M11 5h2" /><path d="M19 12c-.667 5.333 -2.333 8 -5 8h-4c-2.667 0 -4.333 -2.667 -5 -8" /><path d="M11 16c0 .667 .333 1 1 1s1 -.333 1 -1h-2" /><path d="M12 18v2" /><path d="M10 11v.01" /><path d="M14 11v.01" /><path d="M5 4l6 .97l-6.238 6.688a1.021 1.021 0 0 1 -1.41 .111a.953 .953 0 0 1 -.327 -.954l1.975 -6.815" /><path d="M19 4l-6 .97l6.238 6.688c.358 .408 .989 .458 1.41 .111a.953 .953 0 0 0 .327 -.954l-1.975 -6.815" />',
    shirt: '<path d="M15 4l6 2v5h-3v8a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-8h-3v-5l6 -2a3 3 0 0 0 6 0" />',
    'grid-3x3': '<path d="M3 8h18" /><path d="M3 16h18" /><path d="M8 3v18" /><path d="M16 3v18" />',
    wall: '<path d="M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -12" /><path d="M4 8h16" /><path d="M20 12h-16" /><path d="M4 16h16" /><path d="M9 4v4" /><path d="M14 8v4" /><path d="M8 12v4" /><path d="M16 12v4" /><path d="M11 16v4" />',
    car: '<path d="M5 17a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" /><path d="M15 17a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" /><path d="M5 17h-2v-6l2 -5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-6m-6 -6h15m-6 0v-5" />',
    plant:
      '<path d="M7 15h10v4a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2v-4" /><path d="M12 9a6 6 0 0 0 -6 -6h-3v2a6 6 0 0 0 6 6h3" /><path d="M12 11a6 6 0 0 1 6 -6h3v1a6 6 0 0 1 -6 6h-3" /><path d="M12 15l0 -6" />',
    'plant-2':
      '<path d="M2 9a10 10 0 1 0 20 0" /><path d="M12 19a10 10 0 0 1 10 -10" /><path d="M2 9a10 10 0 0 1 10 10" /><path d="M12 4a9.7 9.7 0 0 1 2.99 7.5" /><path d="M9.01 11.5a9.7 9.7 0 0 1 2.99 -7.5" />',
    fence: '<path d="M4 12v4h16v-4l-16 0" /><path d="M6 16v4h4v-4m0 -4v-6l-2 -2l-2 2v6" /><path d="M14 16v4h4v-4m0 -4v-6l-2 -2l-2 2v6" />',
    'building-store':
      '<path d="M3 21l18 0" /><path d="M3 7v1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1h-18l2 -4h14l2 4" /><path d="M5 21l0 -10.15" /><path d="M19 21l0 -10.15" /><path d="M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4" />',
    help: '<path d="M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" /><path d="M12 17l0 .01" /><path d="M12 13.5a1.5 1.5 0 0 1 1 -1.5a2.6 2.6 0 1 0 -3 -4" />',
    check: '<path d="M5 12l5 5l10 -10" />',
    leaf: '<path d="M5 21c.5 -4.5 2.5 -8 7 -10" /><path d="M9 18c6.218 0 10.5 -3.288 11 -12v-2h-4.014c-9 0 -11.986 4 -12 9c0 1 0 3 2 5h3l.014 0" />',
    world:
      '<path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" /><path d="M3.6 9h16.8" /><path d="M3.6 15h16.8" /><path d="M11.5 3a17 17 0 0 0 0 18" /><path d="M12.5 3a17 17 0 0 1 0 18" />',
    'layout-grid':
      '<path d="M4 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -4" /><path d="M14 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -4" /><path d="M4 15a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -4" /><path d="M14 15a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -4" />',
    clock: '<path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" /><path d="M12 7v5l3 3" />',
    snowflake:
      '<path d="M10 4l2 1l2 -1" /><path d="M12 2v6.5l3 1.72" /><path d="M17.928 6.268l.134 2.232l1.866 1.232" /><path d="M20.66 7l-5.629 3.25l.01 3.458" /><path d="M19.928 14.268l-1.866 1.232l-.134 2.232" /><path d="M20.66 17l-5.629 -3.25l-2.99 1.738" /><path d="M14 20l-2 -1l-2 1" /><path d="M12 22v-6.5l-3 -1.72" /><path d="M6.072 17.732l-.134 -2.232l-1.866 -1.232" /><path d="M3.34 17l5.629 -3.25l-.01 -3.458" /><path d="M4.072 9.732l1.866 -1.232l.134 -2.232" /><path d="M3.34 7l5.629 3.25l2.99 -1.738" />',
    wood: '<path d="M6 5.5a6 2.5 0 1 0 12 0a6 2.5 0 1 0 -12 0" /><path d="M18 5.5v4.626a1.415 1.415 0 0 1 1.683 2.18l-.097 .108l-1.586 1.586v4c0 1.61 -2.54 2.925 -5.725 3l-.275 0c-3.314 0 -6 -1.343 -6 -3v-2l-1.586 -1.586a1.414 1.414 0 0 1 1.586 -2.287v-6.627" /><path d="M10 12.5v1.5" /><path d="M14 16v1" />',
    trees:
      '<path d="M16 5l3 3l-2 1l4 4l-3 1l4 4h-9" /><path d="M15 21l0 -3" /><path d="M8 13l-2 -2" /><path d="M8 12l2 -2" /><path d="M8 21v-13" /><path d="M5.824 16a3 3 0 0 1 -2.743 -3.69a3 3 0 0 1 .304 -4.833a3 3 0 0 1 4.615 -3.707a3 3 0 0 1 4.614 3.707a3 3 0 0 1 .305 4.833a3 3 0 0 1 -2.919 3.695h-4l-.176 -.005" />',
    stethoscope:
      '<path d="M6 4h-1a2 2 0 0 0 -2 2v3.5a5.5 5.5 0 0 0 11 0v-3.5a2 2 0 0 0 -2 -2h-1" /><path d="M8 15a6 6 0 1 0 12 0v-3" /><path d="M11 3v2" /><path d="M6 3v2" /><path d="M18 10a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />',
    school: '<path d="M22 9l-10 -4l-10 4l10 4l10 -4v6" /><path d="M6 10.6v5.4a6 3 0 0 0 12 0v-5.4" />',
    shovel:
      '<path d="M17 4l3 3" /><path d="M18.5 5.5l-8 8" /><path d="M8.276 11.284l4.44 4.44a.968 .968 0 0 1 0 1.369l-2.704 2.704a4.108 4.108 0 0 1 -5.809 -5.81l2.704 -2.703a.968 .968 0 0 1 1.37 0l-.001 0" />',
    refresh: '<path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4" /><path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4" />',
    'home-2': '<path d="M5 12l-2 0l9 -9l9 9l-2 0" /><path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" /><path d="M10 12h4v4h-4l0 -4" />',
    wind: '<path d="M5 8h8.5a2.5 2.5 0 1 0 -2.34 -3.24"/><path d="M3 12h15.5a2.5 2.5 0 1 1 -2.34 3.5"/><path d="M4 16h5.5a2.5 2.5 0 1 1 -2.34 3.24"/>',
    dots: '<path d="M5 12a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"/><path d="M11 12a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"/><path d="M17 12a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"/>',
    lock: '<path d="M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"/><path d="M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"/><path d="M8 11v-4a4 4 0 1 1 8 0v4"/>',
    'garden-cart':
      '<path d="M15 17.5a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0" /><path d="M6 8v11a1 1 0 0 0 1.806 .591l3.694 -5.091v.055" /><path d="M6 8h15l-3.5 7l-7.1 -.747a4 4 0 0 1 -3.296 -2.493l-2.853 -7.13a1 1 0 0 0 -.928 -.63h-1.323" />',
    // No Liquid counterpart, so lint-icons.rb reports these as uncovered rather
    // than pretending to check them: `droplets` (blood) and `mood` (vomit) are
    // used only by the finder's mess chips, and neither has been verified against
    // Tabler. Add them to tabler-icon.liquid once the real path data is to hand.
    droplets: '<path d="M9 6.5l-2.3 3.8a2.7 2.7 0 1 0 4.6 0z"/><path d="M15.7 3.5l-1.6 2.7a1.9 1.9 0 1 0 3.2 0z"/>',
    mood: '<path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"/><path d="M9 10l.01 0"/><path d="M15 10l.01 0"/><path d="M9.5 15.25a3.5 3.5 0 0 1 5 0"/>',
  };
  function svgIcon(name, size, stroke) {
    var inner = ICONS[name];
    if (!inner) return '';
    return (
      '<svg viewBox="0 0 24 24" width="' +
      size +
      '" height="' +
      size +
      '" fill="none" stroke="currentColor" stroke-width="' +
      stroke +
      '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      inner +
      '</svg>'
    );
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  // Port of WordmarkText (app/components/brand/Wordmark.tsx): swap every
  // "smellBgone" in an escaped string for the live leaf-b <Wordmark> span. tone
  // is always dark here (finder card bodies sit on the cream/light theme).
  function wordmark(text, leaf) {
    var mark = '<span class="smb-wordmark smb-wordmark--dark" aria-label="smellBgone">smell<img src="' + esc(leaf) + '" alt="" aria-hidden="true">gone</span>';
    return esc(text).split('smellBgone').join(mark);
  }

  // Port of the brand <Select> (app/components/brand/Select.tsx) at size "sm":
  // native select with appearance stripped, mono/700 type and a custom chevron,
  // so the finder size/bags picker matches the DS control (not a plain input).
  function dsSelect(attrs, optsHtml) {
    var selStyle =
      'width:auto;box-sizing:border-box;appearance:none;-webkit-appearance:none;cursor:pointer;' +
      'font-family:var(--font-mono);font-weight:700;color:var(--color-foreground);background:var(--color-background);' +
      'border:1px solid var(--color-border);border-radius:var(--radius-sm);outline:none;' +
      'padding:8px 30px 8px 11px;font-size:13px;';
    return (
      '<div style="position:relative;display:inline-flex;align-items:center;">' +
      '<select ' +
      attrs +
      ' style="' +
      selStyle +
      '">' +
      optsHtml +
      '</select>' +
      '<svg viewBox="0 0 24 24" aria-hidden="true" style="position:absolute;right:12px;width:15px;height:15px;stroke:var(--color-muted);stroke-width:2.2;fill:none;pointer-events:none;"><path d="M6 9l6 6l6 -6"/></svg>' +
      '</div>'
    );
  }

  // Chip icons keyed by mess/surface id (ported from finderWizard.ts).
  var MESS_ICON = { urine: 'droplet', faeces: 'paw', vomit: 'mood', blood: 'droplets', odour: 'wind', other: 'dots', prevent: 'shield-check' };
  var SURFACE_ICON = {
    carpet: 'border-all',
    sofa: 'sofa',
    mattress: 'bed',
    petbed: 'dog',
    fabric: 'shirt',
    floor: 'grid-3x3',
    paving: 'wall',
    car: 'car',
    lawn: 'plant',
    turf: 'plant-2',
    kennel: 'fence',
    commercial: 'building-store',
    unsure: 'help',
  };

  // ---- Benefits (ported from finderBenefits in app/data/finder.ts) -------
  // Icon overview row, shown only on the single/expanded card. One
  // surface-specific slot + fixed trust facts; never repeats the sell sentence.
  var PLUS_SURFACE_BENEFIT = {
    carpet: { icon: 'border-all', label: 'Carpet-safe' },
    sofa: { icon: 'sofa', label: 'Fabric-safe' },
    mattress: { icon: 'bed', label: 'Bedding-safe' },
    petbed: { icon: 'dog', label: 'Pet-bed safe' },
    fabric: { icon: 'shirt', label: 'Fabric-safe' },
    floor: { icon: 'grid-3x3', label: 'No residue' },
    paving: { icon: 'wall', label: 'Paving-safe' },
    car: { icon: 'car', label: 'Car-safe' },
    lawn: { icon: 'plant', label: 'Grass-safe' },
    unsure: { icon: 'layout-grid', label: 'Multi-surface' },
  };
  var PLUS_CONSTANT_BENEFITS = [
    { icon: 'paw', label: 'Pet-safe' },
    { icon: 'leaf', label: 'Biodegradable' },
    { icon: 'world', label: 'Australian made' },
  ];
  var SYNTURF_SURFACE_BENEFIT = {
    turf: { icon: 'plant-2', label: 'Turf-safe' },
    kennel: { icon: 'fence', label: 'Kennel-grade' },
    commercial: { icon: 'building-store', label: 'Commercial-grade' },
  };
  var SYNTURF_CONSTANT_BENEFITS = [
    { icon: 'droplet', label: 'Concentrated' },
    { icon: 'shield-check', label: 'Hospital-grade' },
    { icon: 'paw', label: 'Pet-safe' },
  ];
  var PETFILL_BENEFITS = [
    { icon: 'lock', label: 'Locks ammonia' },
    { icon: 'clock', label: 'Lasts years' },
    { icon: 'snowflake', label: 'Cools turf' },
    { icon: 'paw', label: 'Pet-safe' },
  ];
  function finderBenefits(key, surfaceIds) {
    if (key === 'petfill') return PETFILL_BENEFITS;
    var surface = (surfaceIds && surfaceIds[0]) || '';
    if (key === 'synturf') return [SYNTURF_SURFACE_BENEFIT[surface] || SYNTURF_SURFACE_BENEFIT.turf].concat(SYNTURF_CONSTANT_BENEFITS);
    return [PLUS_SURFACE_BENEFIT[surface] || PLUS_SURFACE_BENEFIT.unsure].concat(PLUS_CONSTANT_BENEFITS);
  }

  // ---- "Built for" tags (ported from app/data/builtFor.ts) ----------------
  // Fallback only now — the live data comes from each product's builtFor
  // array in the finder-products JSON island (custom.built_for, the same
  // field the PDP reads), used whenever that array is empty. The fallback is
  // each product's values as the store holds them since 2026-09-14, in the
  // approved choice-list order, with the icons snippets/built-for-icon.liquid
  // draws (guard/I2 pins both).
  var BUILT_FOR = {
    plus: [
      { icon: 'border-all', label: 'Carpet' },
      { icon: 'sofa', label: 'Upholstery & fabric' },
      { icon: 'bed', label: 'Mattresses & pet beds' },
      { icon: 'car', label: 'Car interiors' },
      { icon: 'grid-3x3', label: 'Tiles' },
      { icon: 'wood', label: 'Timber' },
      { icon: 'wall', label: 'Paving' },
      { icon: 'plant-2', label: 'Synthetic turf' },
    ],
    synturf: [
      { icon: 'plant-2', label: 'Synthetic turf' },
      { icon: 'dog', label: 'Kennels & runs' },
      { icon: 'stethoscope', label: 'Vet & grooming' },
      { icon: 'building-store', label: 'Commercial spaces' },
      { icon: 'school', label: 'Schools & sport' },
      { icon: 'bed', label: 'Aged care' },
    ],
    petfill: [
      { icon: 'plant-2', label: 'Synthetic turf' },
      { icon: 'plant', label: 'Natural lawn' },
      { icon: 'dog', label: 'Kennels & runs' },
    ],
  };

  // Each product's job in a sequenced kit, for the step badge on the image.
  var STEP_VERB = { plus: 'Clean', synturf: 'Sanitise', petfill: 'Protect' };

  // ---- PETFILL bag sizing (ported from app/data/finder.ts) ---------------
  var PETFILL_KG_PER_SQM = 10;
  var PETFILL_BAG_KG = 15;
  function petfillAreaSqm(tier) {
    if (tier === null || tier === undefined) return null;
    var v = TURF_TIER_SQM[tier];
    return v === undefined ? null : v;
  }
  function petfillRecommendedBags(tier) {
    var sqm = petfillAreaSqm(tier);
    if (sqm === null) return null;
    return Math.ceil((sqm * PETFILL_KG_PER_SQM) / PETFILL_BAG_KG);
  }
  function petfillBagOptions(tier) {
    var rec = petfillRecommendedBags(tier);
    if (rec === null) return [];
    var start = Math.max(1, rec - 2);
    var out = [];
    for (var i = 0; i < 6; i++) out.push(start + i);
    return out;
  }

  function recommendIndexForTier(len, tier) {
    return Math.round((tier / 3) * (len - 1));
  }

  // ---- Per-instance controller -------------------------------------------
  function initRoot(root) {
    if (root.__smbFinder) return;
    root.__smbFinder = true;
    var products = {};
    try {
      products = JSON.parse(root.querySelector('[data-finder-products]').textContent);
    } catch (e) {}
    var leafUrl = root.getAttribute('data-leaf') || '';

    var STEPS = ['Mess', 'Where', 'Size', 'Kit'];
    var st = { step: 1, mess: new Set(), prevent: false, surfaces: new Set(), sizeByKind: {}, sizeById: {}, petfillBags: null, petfillBagsTier: undefined };

    var progressEl = root.querySelector('[data-progress]');
    var headingEl = root.querySelector('[data-heading]');
    var screenEl = root.querySelector('[data-screen]');
    var backBtn = root.querySelector('[data-back]');
    var nextBtn = root.querySelector('[data-next]');
    var restartBtn = root.querySelector('[data-restart]');

    function h2(text, mark) {
      if (mark && text.indexOf(mark) !== -1) return text.replace(mark, '<span class="smb-finder-h2-mark">' + mark + '</span>');
      return text;
    }
    // The site's standard button at its md size (brand-button.liquid), for the
    // result cards' Add to cart and Enquire (Sam, 2026-09-30): they had a
    // one-off mono pill of their own.
    function chip(label, active, onclick, iconName) {
      var wrap = document.createElement('span');
      wrap.className = 'smb-finder-chipwrap';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'smb-shop-filter-chip smb-wizard-chip' + (active ? ' is-active' : '');
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
      b.innerHTML = (iconName ? svgIcon(iconName, 16, 1.75) : '') + esc(label);
      b.addEventListener('click', onclick);
      wrap.appendChild(b);
      return wrap;
    }

    function heading() {
      if (st.step === 1) return h2("What's the mess?", 'mess');
      if (st.step === 2) return st.prevent ? h2('Which turf?', 'turf') : h2("Where's the mess?", 'mess');
      if (st.step === 3) {
        var kinds = kindsForSurfaces(st.surfaces);
        if (kinds.length === 1) return h2(SIZE_KINDS[kinds[0]].question, SIZE_KINDS[kinds[0]].mark);
        return h2('The right size', 'size');
      }
      return h2('Your kit', 'kit');
    }

    // Anonymous Pro sets "1"/"2" with their ink left of centre at this size; a
    // small nudge on just those two matches WizardFinder.tsx's STEP_NUM_NUDGE.
    var STEP_NUM_NUDGE = { 1: '2px', 2: '1.2px' };
    function renderProgress() {
      progressEl.innerHTML = '';
      STEPS.forEach(function (label, i) {
        var n = i + 1;
        var done = n < st.step;
        var status = done ? 'Done' : n === st.step ? 'In progress' : 'Up next';
        var numInner = done ? svgIcon('check', 14, 2.75) : String(n);
        var numStyle = done ? '' : ' style="padding-left:' + (STEP_NUM_NUDGE[n] || '0') + '"';
        var dot = document.createElement('div');
        dot.className = 'smb-wizard-step-dot' + (n === st.step ? ' is-current' : '') + (done ? ' is-done' : '');
        dot.innerHTML =
          '<span class="smb-wizard-step-num"' +
          numStyle +
          '>' +
          numInner +
          '</span>' +
          '<span class="smb-wizard-step-text">' +
          '<span class="smb-wizard-step-label">' +
          esc(label) +
          '</span>' +
          '<span class="smb-wizard-step-status" aria-hidden="true">' +
          status +
          '</span>' +
          '</span>';
        progressEl.appendChild(dot);
      });
    }

    function renderStep() {
      screenEl.innerHTML = '';
      var scr = document.createElement('div');
      scr.className = 'smb-wizard-screen';

      if (st.step === 1) {
        scr.innerHTML = '<p class="smb-finder-lede">Pick everything you’re dealing with.</p>';
        var chips = document.createElement('div');
        chips.className = 'smb-wizard-chips smb-wizard-chips--mess';
        MESS_TYPES.forEach(function (m) {
          chips.appendChild(
            chip(
              m.label,
              st.mess.has(m.id),
              function () {
                if (st.mess.has(m.id)) st.mess.delete(m.id);
                else {
                  st.mess.add(m.id);
                  st.prevent = false;
                }
                render();
              },
              MESS_ICON[m.id],
            ),
          );
        });
        chips.appendChild(
          chip(
            PREVENT.label,
            st.prevent,
            function () {
              st.prevent = !st.prevent;
              if (st.prevent) {
                st.mess.clear();
                st.surfaces.clear();
              }
              render();
            },
            MESS_ICON[PREVENT.id],
          ),
        );
        scr.appendChild(chips);
      } else if (st.step === 2) {
        scr.innerHTML =
          '<p class="smb-finder-lede">' + (st.prevent ? 'Confirm the surface you’re protecting.' : 'Tap every spot you’re dealing with.') + '</p>';
        var chips2 = document.createElement('div');
        chips2.className = 'smb-wizard-chips';
        surfacesForMess(st.mess, st.prevent).forEach(function (s) {
          chips2.appendChild(
            chip(
              s.label,
              st.surfaces.has(s.id),
              function () {
                if (st.surfaces.has(s.id)) st.surfaces.delete(s.id);
                else st.surfaces.add(s.id);
                render();
              },
              SURFACE_ICON[s.id],
            ),
          );
        });
        scr.appendChild(chips2);
      } else if (st.step === 3) {
        var kinds = kindsForSurfaces(st.surfaces);
        if (kinds.length === 0) {
          scr.innerHTML = '<p class="smb-wizard-size-empty">These are spot jobs, so the starter size is right. Carry on.</p>';
        } else {
          scr.innerHTML = '<p class="smb-finder-lede">' + (kinds.length === 1 ? SIZE_KINDS[kinds[0]].lede : 'Pick the closest match for each.') + '</p>';
          kinds.forEach(function (kind) {
            var group = document.createElement('div');
            group.className = 'smb-wizard-size-group';
            if (kinds.length > 1) group.innerHTML = '<div class="smb-finder-refine-head">' + SIZE_KINDS[kind].prompt + '</div>';
            var chips3 = document.createElement('div');
            chips3.className = 'smb-wizard-chips';
            SIZE_KINDS[kind].options.forEach(function (o) {
              chips3.appendChild(
                chip(o.label, st.sizeByKind[kind] === o.id, function () {
                  st.sizeByKind[kind] = o.id;
                  render();
                }),
              );
            });
            group.appendChild(chips3);
            scr.appendChild(group);
          });
        }
      } else {
        renderResult(scr);
      }
      screenEl.appendChild(scr);
    }

    // Read-only pill chips (icon + label) for the "For tackling X on Y" recap.
    function recapChipsHtml(items) {
      return items
        .map(function (it, i) {
          var sep = i === 0 ? '' : i === items.length - 1 ? ' and ' : ', ';
          var ico = it.icon ? svgIcon(it.icon, 13, 1.9) : '';
          return sep + '<span class="smb-finder-recap-chip">' + ico + esc(it.label) + '</span>';
        })
        .join('');
    }

    function renderResult(scr) {
      var kit = resolveKit(st.surfaces, st.sizeByKind, st.prevent);
      // Drop entries whose product slot is unset in the section settings BEFORE
      // anything is measured off the kit. Filtering later (at render time) left
      // `single`, the "Step n" badges and the scroll dots counting cards that
      // were never drawn: one visible card could render narrow and numbered
      // "2", with no "1" anywhere, or the recap sentence could sit above an
      // empty card row.
      kit = kit.filter(function (entry) {
        return products[entry.key];
      });
      if (!kit.length) {
        scr.innerHTML = '<p class="smb-finder-empty">Pick a surface to see your kit.</p>';
        return;
      }
      var single = kit.length === 1;

      // Recap: the mess + surfaces they picked, tied into a sentence above the
      // recommendation (size lives with each card, not here).
      var recapMess = st.prevent
        ? []
        : MESS_TYPES.filter(function (m) {
            return st.mess.has(m.id);
          }).map(function (m) {
            return { label: m.label, icon: MESS_ICON[m.id] };
          });
      var recapSurfaces = SURFACES.filter(function (s) {
        return st.surfaces.has(s.id);
      }).map(function (s) {
        return { label: s.label, icon: SURFACE_ICON[s.id] };
      });
      var hasRecap = recapSurfaces.length > 0 && (st.prevent || recapMess.length > 0);
      if (hasRecap) {
        var recap = document.createElement('p');
        recap.className = 'smb-finder-recap';
        recap.innerHTML = st.prevent
          ? 'For protecting your new ' + recapChipsHtml(recapSurfaces) + ' we recommend:'
          : 'For tackling ' + recapChipsHtml(recapMess) + ' on ' + recapChipsHtml(recapSurfaces) + ' we recommend:';
        scr.appendChild(recap);
      }

      var cards = document.createElement('div');
      cards.className = 'smb-finder-cards' + (single ? ' smb-finder-cards--single' : '');
      cards.style.marginTop = '18px';
      // Multi-card kits scroll horizontally on narrow screens; a scrollable
      // region has to be keyboard-reachable and labelled.
      if (!single) {
        cards.setAttribute('role', 'group');
        cards.setAttribute('aria-label', 'Your kit');
        cards.setAttribute('tabindex', '0');
      }

      // Every card's name at one size, fitted to the longest name in the kit
      // (page-shop.css divides the card's width by it), so SYNTURF does not
      // wrap where PETFILL fits (critique, 2026-10-03).
      var nameChars = 0;
      kit.forEach(function (entry) {
        var np = products[entry.key];
        if (np && np.title) nameChars = Math.max(nameChars, np.title.length);
      });
      cards.style.setProperty('--name-chars', String(nameChars || 16));

      kit.forEach(function (entry, i) {
        var p = products[entry.key];
        if (!p) return;
        var numbered = !single; // sequenced kits number each card
        var card = document.createElement('div');
        card.className = 'smb-finder-card' + (single ? ' smb-finder-card--wide' : '') + (numbered ? ' smb-finder-card--numbered' : '');
        var why = finderWhy(entry.key, st.mess, entry.surfaces, entry.companion);
        var sizeReason = entry.hasArea && entry.tier !== null ? entry.reason || 'for your area' : 'to start with';

        // Numbered step badge + verb, shown only on multi-card kits.
        var badge = numbered
          ? '<span class="smb-finder-card-num" aria-label="Step ' +
            (i + 1) +
            '">' +
            (i + 1) +
            '</span>' +
            '<span class="smb-finder-step-tag">' +
            esc(STEP_VERB[entry.key] || '') +
            '</span>'
          : '';

        // Benefits + "Built for" only on the single/expanded card.
        var benefitsHtml = '';
        var builtForHtml = '';
        if (single) {
          benefitsHtml =
            '<ul class="smb-finder-card-benefits">' +
            finderBenefits(entry.key, entry.surfaces)
              .map(function (b) {
                return '<li class="smb-finder-benefit">' + svgIcon(b.icon, 16, 1.75) + esc(b.label) + '</li>';
              })
              .join('') +
            '</ul>';
          var tags = p.builtFor && p.builtFor.length ? p.builtFor : BUILT_FOR[entry.key] || [];
          if (tags.length) {
            builtForHtml =
              '<div class="smb-finder-card-builtfor">' +
              '<span class="smb-finder-card-builtfor-label">Built for</span>' +
              '<div class="smb-finder-card-builtfor-tags">' +
              tags
                .map(function (t) {
                  return '<span class="smb-finder-card-builtfor-tag">' + svgIcon(t.icon, 14, 1.75) + esc(t.label) + '</span>';
                })
                .join('') +
              '</div></div>';
          }
        }

        var control = '';
        var foot = '';
        if (entry.key === 'petfill') {
          // Priced-to-order enquiry: link to the PDP #enquire flow with the
          // estimated area (+ bag count), matching WizardFinder.tsx. The theme
          // PDP form (main-product.liquid #enquire) doesn't yet pre-fill from
          // ?area=/?bags=, but the deep link matches the live target/label.
          var tier = entry.tier;
          var recBags = petfillRecommendedBags(tier);
          if (st.petfillBagsTier !== tier) {
            st.petfillBags = null;
            st.petfillBagsTier = tier;
          }
          var bagCount = st.petfillBags != null ? st.petfillBags : recBags;
          var areaSqm = petfillAreaSqm(tier);
          var base = p.url || '#';
          var enqHref = areaSqm !== null ? base + '?area=' + areaSqm + (bagCount != null ? '&bags=' + bagCount : '') + '#enquire' : base + '#enquire';
          var bagOpts = petfillBagOptions(tier);
          if (bagOpts.length) {
            var bopts = bagOpts
              .map(function (n) {
                return '<option value="' + n + '"' + (n === bagCount ? ' selected' : '') + '>' + n + '</option>';
              })
              .join('');
            var bagsId = 'w-bags-' + entry.key;
            control =
              '<div class="smb-finder-size">' +
              '<label class="smb-finder-size-label" for="' +
              bagsId +
              '">Bags</label>' +
              dsSelect('id="' + bagsId + '" data-bags', bopts) +
              '<span class="smb-finder-size-unit">&times; 15kg</span>' +
              '<span class="smb-finder-size-note">' +
              esc(sizeReason) +
              '</span>' +
              '</div>';
          }
          foot =
            '<span class="smb-finder-card-price">Priced to order</span>' +
            '<a class="smb-btn smb-btn--secondary smb-finder-cta" href="' +
            enqHref +
            '" target="_blank" rel="noopener noreferrer">Enquire' +
            svgIcon('arrow-right', 16, 2.2) +
            '</a>';
        } else {
          var vs = p.variants || [];
          var tierN = entry.tier === null ? 0 : entry.tier;
          var idx = vs.length ? recommendIndexForTier(vs.length, tierN) : 0;
          if (st.sizeById[entry.key]) {
            vs.forEach(function (v, j) {
              if (String(v.id) === String(st.sizeById[entry.key])) idx = j;
            });
          }
          var chosen = vs[idx];
          var opts = vs
            .map(function (v, j) {
              return '<option value="' + v.id + '"' + (j === idx ? ' selected' : '') + '>' + esc(v.label) + '</option>';
            })
            .join('');
          foot =
            '<span class="smb-finder-card-price">' +
            (chosen ? chosen.price : '') +
            '</span>' +
            '<button type="button" class="smb-btn smb-btn--primary smb-finder-cta" data-add="' +
            (chosen ? chosen.id : '') +
            '">Add to cart' +
            svgIcon('garden-cart', 16, 2.2) +
            '</button>';
          if (vs.length > 1) {
            var sizeId = 'w-size-' + entry.key;
            control =
              '<div class="smb-finder-size"><label class="smb-finder-size-label" for="' +
              sizeId +
              '">Size</label>' +
              dsSelect('id="' + sizeId + '" data-size-for="' + entry.key + '"', opts) +
              '<span class="smb-finder-size-note">' +
              esc(sizeReason) +
              '</span></div>';
          }
        }

        card.innerHTML =
          badge +
          '<div class="smb-finder-card-media">' +
          // The product photo's admin focal point frames its crop.
          (p.image
            ? '<img src="' + p.image + '" alt="' + esc(p.title || '') + '"' + (p.imageFocal ? ' style="object-position:' + esc(p.imageFocal) + '"' : '') + '>'
            : '') +
          '</div>' +
          '<div class="smb-finder-card-body" data-theme="light">' +
          '<div class="smb-finder-card-eyebrow">' +
          esc(p.eyebrow || '') +
          '</div>' +
          '<a class="smb-finder-card-title" href="' +
          (p.url || '#') +
          '">' +
          wordmark(p.title || '', leafUrl) +
          '</a>' +
          '<p class="smb-finder-card-why">' +
          esc(why) +
          '</p>' +
          benefitsHtml +
          builtForHtml +
          control +
          '<div class="smb-finder-card-foot">' +
          foot +
          '</div>' +
          '</div>';
        cards.appendChild(card);
      });
      scr.appendChild(cards);

      // The whole kit in one press, with its total, when 2 or more cards can
      // be bought outright (critique, 2026-10-03: a 2-step kit had no total
      // and no way to add both). A priced-to-order card is left out of both:
      // it is an enquiry, not a price. The total is the chosen sizes' live
      // prices summed, so it moves when a size select does.
      var buyable = [];
      kit.forEach(function (entry) {
        var bp = products[entry.key];
        if (!bp || entry.key === 'petfill') return;
        var bvs = bp.variants || [];
        if (!bvs.length) return;
        var bidx = recommendIndexForTier(bvs.length, entry.tier === null ? 0 : entry.tier);
        if (st.sizeById[entry.key]) {
          bvs.forEach(function (v, j) {
            if (String(v.id) === String(st.sizeById[entry.key])) bidx = j;
          });
        }
        buyable.push(bvs[bidx]);
      });
      if (buyable.length >= 2) {
        var cents = buyable.reduce(function (sum, v) {
          return sum + (Number(v.cents) || 0);
        }, 0);
        var kitBar = document.createElement('div');
        kitBar.className = 'smb-finder-kitbar';
        kitBar.innerHTML =
          '<span class="smb-finder-kitbar-total"><span class="smb-finder-kitbar-label">Kit total</span> <span class="smb-finder-kitbar-price">$' +
          (cents / 100).toFixed(2) +
          '</span></span>' +
          '<button type="button" class="smb-btn smb-btn--primary smb-finder-kitbar-add">Add the kit to cart' +
          svgIcon('garden-cart', 16, 2.2) +
          '</button>';
        scr.appendChild(kitBar);
        var kitBtn = kitBar.querySelector('button');
        kitBtn.addEventListener('click', function () {
          addToCart(
            buyable.map(function (v) {
              return v.id;
            }),
            kitBtn,
          );
        });
      }

      // Multi-card scroll affordance — dots under the row (hidden until it overflows).
      if (!single) mountScrollDots(cards, scr);

      // wire size selects + bag selects + add buttons
      cards.querySelectorAll('[data-size-for]').forEach(function (sel) {
        sel.addEventListener('change', function () {
          st.sizeById[sel.getAttribute('data-size-for')] = sel.value;
          render();
        });
      });
      cards.querySelectorAll('[data-bags]').forEach(function (sel) {
        sel.addEventListener('change', function () {
          st.petfillBags = Number(sel.value);
          render();
        });
      });
      cards.querySelectorAll('[data-add]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          addToCart(btn.getAttribute('data-add'), btn);
        });
      });
    }

    // Scroll affordance for the multi-card carousel: one dot per card, lit for
    // each card in view. Ported from app/components/ScrollDots.tsx; attaches to
    // the row passed in and inserts its dots immediately after it.
    function mountScrollDots(row, scr) {
      var dots = document.createElement('div');
      dots.className = 'smb-scroll-dots';
      dots.setAttribute('aria-hidden', 'true');
      scr.appendChild(dots);
      function update() {
        var kids = Array.prototype.slice.call(row.children);
        if (kids.length < 2 || row.scrollWidth <= row.clientWidth + 1) {
          dots.removeAttribute('data-active');
          dots.innerHTML = '';
          return;
        }
        var box = row.getBoundingClientRect();
        var shown = [];
        var bestFit = 0;
        var mostVisible = -1;
        kids.forEach(function (card, i) {
          var r = card.getBoundingClientRect();
          var overlap = Math.min(r.right, box.right) - Math.max(r.left, box.left);
          var ratio = r.width > 0 ? overlap / r.width : 0;
          if (ratio > mostVisible) {
            mostVisible = ratio;
            bestFit = i;
          }
          if (ratio >= 0.6) shown.push(i);
        });
        if (!shown.length) shown = [bestFit];
        dots.setAttribute('data-active', '');
        dots.innerHTML = '';
        for (var i = 0; i < kids.length; i++) {
          var d = document.createElement('span');
          d.className = 'smb-scroll-dots-dot';
          if (shown.indexOf(i) !== -1) d.setAttribute('data-current', '');
          dots.appendChild(d);
        }
      }
      update();
      row.addEventListener('scroll', update, { passive: true });
      if (typeof ResizeObserver !== 'undefined') {
        var ro = new ResizeObserver(update);
        ro.observe(row);
        Array.prototype.slice.call(row.children).forEach(function (c) {
          ro.observe(c);
        });
      }
    }

    // One variant id or several (the kit). Like every other add path it
    // pulls the drawer's real content in and opens it (smb-cart-drawer.js);
    // it used to bump the badge only, so the drawer showed the old cart.
    function addToCart(variantIds, btn) {
      var ids = [].concat(variantIds).filter(Boolean);
      if (!ids.length || !window.fetch) return;
      var label = btn.innerHTML;
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: ids.map(function (id) {
            return { id: id, quantity: 1 };
          }),
        }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add refused');
          if (window.smbCartDrawer) return window.smbCartDrawer.refresh().then(window.smbCartDrawer.open);
          return fetch('/cart.js')
            .then(function (res) {
              return res.json();
            })
            .then(function (cart) {
              var badge = document.querySelector('[data-cart-count]');
              if (badge) badge.textContent = cart.item_count;
            });
        })
        .then(function () {
          btn.textContent = 'Added';
          setTimeout(function () {
            btn.innerHTML = label;
            btn.disabled = false;
          }, 1400);
        })
        .catch(function () {
          btn.innerHTML = label;
          btn.disabled = false;
        });
    }

    function canNext() {
      return (st.step === 1 && (st.mess.size > 0 || st.prevent)) || (st.step === 2 && st.surfaces.size > 0) || st.step === 3;
    }
    function restart() {
      st.step = 1;
      st.mess = new Set();
      st.prevent = false;
      st.surfaces = new Set();
      st.sizeByKind = {};
      st.sizeById = {};
      st.petfillBags = null;
      st.petfillBagsTier = undefined;
      render();
    }
    function render() {
      renderProgress();
      headingEl.innerHTML = heading();
      renderStep();
      // Back keeps its place on step 1 (hidden, not removed), so Next stays on
      // the right at every step instead of jumping left (critique,
      // 2026-10-03). visibility also takes it out of the tab order.
      backBtn.style.visibility = st.step === 1 ? 'hidden' : '';
      nextBtn.style.display = st.step === 4 ? 'none' : '';
      nextBtn.disabled = !canNext();
      // Step 4 swaps Next for a Start over button.
      if (restartBtn) restartBtn.style.display = st.step === 4 ? '' : 'none';
    }

    // Deep link from marketing: /?mess=urine#finder seeds step 1 and opens on
    // step 2, so a chip clicked in an email continues the wizard rather than
    // restarting it. Unknown ids are ignored; 'prevent' wins over any mess.
    function applyUrlPreset() {
      var q;
      try {
        q = new URLSearchParams(window.location.search);
      } catch (e) {
        return;
      }
      var raw = q.get('mess');
      if (!raw) return;
      var valid = MESS_TYPES.map(function (m) {
        return m.id;
      });
      var picked = false;
      raw.split(',').forEach(function (s) {
        var id = s.trim().toLowerCase();
        if (!id) return;
        if (id === PREVENT.id) {
          st.prevent = true;
          st.mess.clear();
          picked = true;
          return;
        }
        if (!st.prevent && valid.indexOf(id) !== -1) {
          st.mess.add(id);
          picked = true;
        }
      });
      if (picked) st.step = 2;
    }

    backBtn.addEventListener('click', function () {
      if (st.step > 1) {
        st.step--;
        render();
      }
    });
    nextBtn.addEventListener('click', function () {
      if (canNext() && st.step < 4) {
        st.step++;
        render();
      }
    });
    if (restartBtn) restartBtn.addEventListener('click', restart);
    applyUrlPreset();
    render();
  }

  function scan() {
    document.querySelectorAll('[data-finder-root]').forEach(initRoot);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-finder-root]').forEach(initRoot);
  });
})();
